import { take, call, put, select, race } from 'redux-saga/effects';

import { loadDataAction,loadDataDoneAction } from 'modules/app/actions';
import { LOGIN, LOGOUT } from 'modules/auth/constants/actionTypes';
import { login as loginAction } from 'modules/auth/actions';
import { loginUser } from '../repository';


function *authorize({username, password}) {
    yield put(loadDataAction('login'));
    try {
        const {jwt, sessionData} = yield call(loginUser(username, password));
        yield put(loginAction.success(jwt, sessionData));
    } catch(error) {
        yield put(loginAction.error(error));
    }
    yield put(loadDataDoneAction('login'));
}

export function *login() {
    while(true) {
        const {username, password} = yield take(LOGIN.REQUEST);

        yield race([
            take(LOGOUT),
            call(authorize, {username, password})
        ]);
    }
}
